{
    "Section_Header": "Enviar para Opções:",
    "Section_SubHeader": "Enviar relatórios para:",
    "Validation_Valid_Domain_Name": "O e-mail deve ser válido.",
    "Validation_Valid_Same_As_User": "O e-mail deve pertencer ao mesmo domínio do usuário atual.",
    "Validation_Valid_Non_Blacklisted_Email": "O e-mail não deve estar em um domínio da lista negra.",
    "Validation_Valid_Max_Custom_Domains": "Você só pode adicionar no máximo {} e-mails personalizados.",
    "Validation_Valid_Max_Entries": "Você não pode ter mais de {} e-mails",
    "NAME": "ReportSchedulingEmails"
}